import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import { useEffect, useState } from "react";
import Breadcrumb from 'Components/Common/Breadcrumb';

const DirectoryIndex = () => {

  const [manualList, setManualList] = useState<any>([]);

  useEffect(() => {
    setManualList([
      {
        title: 'Нэвтрэх заавар',
        videoName: 'login.mp4',
        profile: 'rec1.png',
      },
      {
        title: 'Нуур тойром бүртгэх',
        videoName: 'reg_lake.mp4',
        // profile: 'reg_lake.jpg',
      },
      {
        title: 'Гол мөрөн бүртгэх',
        videoName: 'reg_river.mp4',
        // profile: 'reg_lake.jpg',
      },

    ])

  }, []);
  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Системийн удирдлага" breadcrumbItem="Гарын авлага" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <CardTitle tag="h5" className="mb-0 flex-grow-1">Заавар бичлэгүүд</CardTitle>
                  </div>
                  <Row>
                    {
                      manualList?.map((item, index) => (
                        <Col key={index} lg={3} md={6} sm={12}>
                          <Card>
                            <CardBody>
                              <CardTitle tag="h4">{item?.title}</CardTitle>
                              <div className="embed-responsive embed-responsive-16by9 ratio ratio-16x9">
                                <video src={`/assets/manual/${item?.videoName}`}
                                  poster={`/assets/manual/${item?.profile}`}
                                  controls
                                  controlsList="nodownload"
                                  onContextMenu={(e) => e.preventDefault()}></video>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      ))
                    }
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default DirectoryIndex;